import { render, staticRenderFns } from "./NotificationSuggestionIcon.vue?vue&type=template&id=f75f3ed8&"
import script from "./NotificationSuggestionIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationSuggestionIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports